export default {
  title: 'Unterzeichnet / Live Bericht',
  column_groups: {
    current_period: 'Aktueller Zeitraum',
  },
  fields: {
    name: 'Name',
    area: 'Bereich',
    signed: 'Unterzeichnet',
    live: 'Live',
    going_live: 'Geht live',
    going_live_avg: 'Geht live Durchschn.',
    churned: 'Abgebrochen',
    not_live: 'Nicht live',
    live_ratio: 'Live-Quote',
    avg_mrr: 'Ø MRR',
  },
  manager_status_filters: {
    active: 'Aktiv',
    inactive: 'Inaktiv',
    all: 'Alle',
  },
  status_filters: {
    all: 'Alle',
    not_live: 'Nicht live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} Restaurant',
    subtitle_other: '{{count}} Restaurants',
    empty: 'Keine Restaurants gefunden.',
  },
  toasts: {
    failed_to_load_data: 'Die Daten konnten nicht geladen werden, bitte aktualisieren Sie die Seite',
  },
};
